import { useQuery } from "@tanstack/react-query";
import { useIdentityClient, useToken } from "@packsize/authentication";

import { type TenantTimezone } from "@/schemas";
import { getTenantTimezone } from "@/api/identity-api";

interface UseTenantTimezoneOptions {
	retry?: boolean;
	refetchInterval?: number | false;
	refetchOnWindowFocus?: boolean;
	refetchOnReconnect?: boolean;
}

export const useTenantTimezone = (options?: UseTenantTimezoneOptions) => {
	const { client } = useIdentityClient();
	const { decodedToken } = useToken();

	const tenantId = decodedToken?.tid;
	const queryFn = () => getTenantTimezone(client);

	return useQuery<TenantTimezone | null>({
		queryKey: ["tenant-timezone"],
		gcTime: 60 * 60 * 1000,
		staleTime: 60 * 60 * 1000,
		enabled: Boolean(tenantId),
		queryFn,
		...options,
	});
};
